import PropTypes from 'prop-types';
import React from 'react';
import { Field } from 'redux-form/immutable';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import DragHandleIcon from '@mui/icons-material/DragHandle';

import makeSortableItem from 'retired/SortableItem';
import FormTextField from 'retired/FormTextField';
import * as validators from 'utils/validators';

const required = validators.required();

const Milestone = ({ milestone, remove }) => (
  <div
    key={milestone}
    style={{
      display: 'flex',
      alignItems: 'flex-start',
      border: '1px solid rgba(0, 0, 0, 0.2)',
      padding: 15,
    }}
  >
    <div>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <DragHandleIcon />
      </div>
      <Field
        name={`${milestone}.name`}
        component={FormTextField}
        fullWidth
        style={{ marginBottom: 10 }}
        label="Milestone name *"
        validate={required}
      />
      <Field
        name={`${milestone}.description`}
        component={FormTextField}
        inputProps={{ maxLength: 500 }}
        fullWidth
        multiline
        label="Description *"
        validate={required}
      />
    </div>
    <IconButton title="Remove milestone" onClick={remove} tooltip="bottom-right">
      <DeleteIcon />
    </IconButton>
  </div>
);
Milestone.propTypes = {
  milestone: PropTypes.string,
  remove: PropTypes.func,
};

export default makeSortableItem({
  itemType: 'milestone',
  wrapperStyle: {
    paddingTop: 6,
    paddingBottom: 2,
  },
})(Milestone);
